var IncidentColumns;
(function (IncidentColumns) {
    IncidentColumns["Type"] = "type";
    IncidentColumns["Description"] = "description";
    IncidentColumns["IncidentDate"] = "incident_date";
})(IncidentColumns || (IncidentColumns = {}));

var InvoiceStatusEnum;
(function (InvoiceStatusEnum) {
    InvoiceStatusEnum["Pay to reinstate"] = "writeoff";
    InvoiceStatusEnum["Unpaid"] = "posted";
    InvoiceStatusEnum["Paid"] = "paid";
})(InvoiceStatusEnum || (InvoiceStatusEnum = {}));
var MyInvoicesColumns;
(function (MyInvoicesColumns) {
    MyInvoicesColumns["ContributionDate"] = "date";
    MyInvoicesColumns["InvoiceDate"] = "invoice_date";
    MyInvoicesColumns["InvoiceNumber"] = "invoice_number";
    MyInvoicesColumns["Status"] = "status";
    MyInvoicesColumns["Amount"] = "amount";
    MyInvoicesColumns["AmountWithTax"] = "amount_with_tax";
    MyInvoicesColumns["Price"] = "price";
    MyInvoicesColumns["SettlementAmountWithTax"] = "settlement_amount_with_tax";
    MyInvoicesColumns["PersonFullName"] = "person.full_name";
    MyInvoicesColumns["PersonFirstName"] = "person_first_name";
    MyInvoicesColumns["PersonLastName"] = "person_last_name";
    MyInvoicesColumns["DueDate"] = "due_date";
    MyInvoicesColumns["OfficeName"] = "office_name";
    MyInvoicesColumns["PersonName"] = "person_name";
    MyInvoicesColumns["DueOrPaidDate"] = "due_or_paid_date";
    MyInvoicesColumns["ProductGroupName"] = "product_group_name";
    MyInvoicesColumns["PaymentRef"] = "payment_ref";
    MyInvoicesColumns["Name"] = "name";
    MyInvoicesColumns["PaymentStatus"] = "payment_status";
    MyInvoicesColumns["CheckedToPay"] = "checked_to_pay";
    MyInvoicesColumns["ProductInvoiceItemDescription"] = "product_invoice_item_description";
})(MyInvoicesColumns || (MyInvoicesColumns = {}));
var InvoiceProps;
(function (InvoiceProps) {
    InvoiceProps["InvoiceDate"] = "invoice_date";
    InvoiceProps["InvoiceNumber"] = "invoice_number";
    InvoiceProps["Status"] = "status";
    InvoiceProps["Amount"] = "amount";
    InvoiceProps["AmountWithTax"] = "amount_with_tax";
    InvoiceProps["SettlementAmountWithTax"] = "settlement_amount_with_tax";
    InvoiceProps["PersonFullName"] = "person.full_name";
    InvoiceProps["PersonFirstName"] = "person_first_name";
    InvoiceProps["PersonLastName"] = "person_last_name";
    InvoiceProps["DueDate"] = "due_date";
    InvoiceProps["OfficeName"] = "office_name";
    InvoiceProps["PersonName"] = "person_name";
    InvoiceProps["DueOrPaidDate"] = "due_or_paid_date";
    InvoiceProps["ProductGroupName"] = "product_group_name";
    InvoiceProps["PaymentRef"] = "payment_ref";
    InvoiceProps["Name"] = "name";
    InvoiceProps["PaymentStatus"] = "payment_status";
    InvoiceProps["CheckedToPay"] = "checked_to_pay";
})(InvoiceProps || (InvoiceProps = {}));

var RecnPaymentMethodType;
(function (RecnPaymentMethodType) {
    RecnPaymentMethodType["CreditCard"] = "creditCard";
    RecnPaymentMethodType["Check"] = "check";
    RecnPaymentMethodType["SavedCreditCard"] = "savedCreditCard";
})(RecnPaymentMethodType || (RecnPaymentMethodType = {}));

var MyPaymentsColumns;
(function (MyPaymentsColumns) {
    MyPaymentsColumns["Date"] = "payment_date";
    MyPaymentsColumns["Reference"] = "payment_ref";
    MyPaymentsColumns["Amount"] = "payment_amount";
    MyPaymentsColumns["Receipt"] = "receipt";
})(MyPaymentsColumns || (MyPaymentsColumns = {}));
var PaymentStepStatus;
(function (PaymentStepStatus) {
    PaymentStepStatus["InProgress"] = "in progress";
    PaymentStepStatus["Unprocessed"] = "unprocessed";
    PaymentStepStatus["Success"] = "success";
    PaymentStepStatus["Danger"] = "danger";
    PaymentStepStatus["Error"] = "error";
})(PaymentStepStatus || (PaymentStepStatus = {}));

var PersonProps;
(function (PersonProps) {
    PersonProps["FullName"] = "full_name";
    PersonProps["LicenseNumber"] = "license_number";
    PersonProps["Email"] = "email";
    PersonProps["Mobile"] = "mobile";
    PersonProps["TicketPrice"] = "ticket_price";
})(PersonProps || (PersonProps = {}));

var PersonSubscriptionProps;
(function (PersonSubscriptionProps) {
    PersonSubscriptionProps["Type"] = "type";
    PersonSubscriptionProps["Office"] = "office_label";
    PersonSubscriptionProps["Role"] = "role";
    PersonSubscriptionProps["Status"] = "status";
    PersonSubscriptionProps["ShowStatus"] = "show_status";
    PersonSubscriptionProps["ShowRole"] = "show_role";
    PersonSubscriptionProps["PaidUntil"] = "paid_until";
})(PersonSubscriptionProps || (PersonSubscriptionProps = {}));

var BillingEntityProps;
(function (BillingEntityProps) {
    BillingEntityProps["Name"] = "name";
    BillingEntityProps["City"] = "city";
    BillingEntityProps["ContactFullName"] = "contact_full_name";
    BillingEntityProps["Phone"] = "contact_phone";
    BillingEntityProps["EntityAssociationNRDSId"] = "entity_association_nrds_id";
})(BillingEntityProps || (BillingEntityProps = {}));

var CreditRequestProps;
(function (CreditRequestProps) {
    CreditRequestProps["CreditRequestId"] = "credit_request_id";
    CreditRequestProps["AssociationPaymentItemId"] = "association_payment_item_id";
    CreditRequestProps["Status"] = "status";
    CreditRequestProps["RefundReason"] = "refund_reason";
    CreditRequestProps["RejectedReason"] = "rejected_reason";
    CreditRequestProps["Amount"] = "amount";
    CreditRequestProps["RequestedBy"] = "requested_by";
    CreditRequestProps["InvoiceId"] = "invoice_id";
    CreditRequestProps["Filename"] = "filename";
    CreditRequestProps["EcControlNumber"] = "ec_control_number";
    CreditRequestProps["MemberNrdsId"] = "member_nrds_id";
    CreditRequestProps["AssociationName"] = "association_name";
    CreditRequestProps["PaymentType"] = "payment_type";
    CreditRequestProps["SettlementDate"] = "settlement_date";
    CreditRequestProps["MemberFirstName"] = "member_first_name";
    CreditRequestProps["MemberLastName"] = "member_last_name";
    CreditRequestProps["MemberFullName"] = "member_full_name";
    CreditRequestProps["CreatedAt"] = "created_at";
    CreditRequestProps["UpdatedAt"] = "updated_at";
})(CreditRequestProps || (CreditRequestProps = {}));

var InvoiceActivityProps;
(function (InvoiceActivityProps) {
    InvoiceActivityProps["Processed"] = "processed";
    InvoiceActivityProps["Level"] = "level";
    InvoiceActivityProps["Status"] = "status";
    InvoiceActivityProps["Rule"] = "rule";
    InvoiceActivityProps["Description"] = "description";
    InvoiceActivityProps["BillingInfo"] = "billing_info";
})(InvoiceActivityProps || (InvoiceActivityProps = {}));

var BillingEntityUserProps;
(function (BillingEntityUserProps) {
    BillingEntityUserProps["FirstName"] = "first_name";
    BillingEntityUserProps["LastName"] = "last_name";
    BillingEntityUserProps["IdpIdentifier"] = "idp_identifier";
    BillingEntityUserProps["Status"] = "status";
})(BillingEntityUserProps || (BillingEntityUserProps = {}));

var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["InProgress"] = "Payment in Progress";
    PaymentStatus["Draft"] = "Draft";
    PaymentStatus["Chargedback"] = "Chargedback";
    PaymentStatus["PayToReinstate"] = "Pay to Reinstate";
    PaymentStatus["WrittingOff"] = "Writting Off";
    PaymentStatus["Paid"] = "Paid";
    PaymentStatus["Unpaid"] = "Unpaid";
})(PaymentStatus || (PaymentStatus = {}));

var RSVP;
(function (RSVP) {
    RSVP["Invited"] = "invited";
    RSVP["Accepted"] = "accepted";
    RSVP["Declined"] = "declined";
})(RSVP || (RSVP = {}));
var AttendanceType;
(function (AttendanceType) {
    AttendanceType["No"] = "no";
    AttendanceType["InPerson"] = "in person";
    AttendanceType["Virtual"] = "virtual";
})(AttendanceType || (AttendanceType = {}));

var CommitteeStaffProps;
(function (CommitteeStaffProps) {
    CommitteeStaffProps["Name"] = "name";
    CommitteeStaffProps["CommitteeTypeName"] = "committee_type_name";
    CommitteeStaffProps["CommitteeLiason"] = "committee_staff.name";
    CommitteeStaffProps["Status"] = "status";
})(CommitteeStaffProps || (CommitteeStaffProps = {}));

var CommitteeTypeProps;
(function (CommitteeTypeProps) {
    CommitteeTypeProps["Label"] = "label";
})(CommitteeTypeProps || (CommitteeTypeProps = {}));

var MeetingColumns;
(function (MeetingColumns) {
    MeetingColumns["CommitteeName"] = "committee_name";
    MeetingColumns["Date"] = "date";
    MeetingColumns["Rsvp"] = "rsvp";
    MeetingColumns["Attended"] = "attended";
})(MeetingColumns || (MeetingColumns = {}));

var TermProps;
(function (TermProps) {
    TermProps["Label"] = "label";
    TermProps["StartDate"] = "term_start_date";
    TermProps["EndDate"] = "term_end_date";
    TermProps["Status"] = "status";
    TermProps["Positions"] = "positions";
    TermProps["CreatedAt"] = "created_at";
    TermProps["UpdatedAt"] = "updated_at";
})(TermProps || (TermProps = {}));
var TermStatusEnum;
(function (TermStatusEnum) {
    TermStatusEnum["Upcoming"] = "Upcoming";
    TermStatusEnum["Applications_open"] = "Applications Open";
    TermStatusEnum["Current"] = "Current";
    TermStatusEnum["Past"] = "Past";
})(TermStatusEnum || (TermStatusEnum = {}));
var TermApplicationTypeEnum;
(function (TermApplicationTypeEnum) {
    TermApplicationTypeEnum["None"] = "none";
    TermApplicationTypeEnum["Self"] = "self";
    TermApplicationTypeEnum["Proposer"] = "proposer";
})(TermApplicationTypeEnum || (TermApplicationTypeEnum = {}));

var TermMemberColumns;
(function (TermMemberColumns) {
    TermMemberColumns["Name"] = "name";
    TermMemberColumns["Term"] = "term_label";
    TermMemberColumns["Position"] = "position_name";
    TermMemberColumns["PositionStart"] = "start_date";
    TermMemberColumns["PositionEnd"] = "end_date";
    TermMemberColumns["Mobile"] = "mobile";
    TermMemberColumns["Email"] = "email";
})(TermMemberColumns || (TermMemberColumns = {}));

var PositionProps;
(function (PositionProps) {
    PositionProps["Name"] = "name";
    PositionProps["Active"] = "active";
    PositionProps["Staff"] = "staff";
    PositionProps["Required"] = "required";
    PositionProps["VotingPosition"] = "voting_postion";
    PositionProps["Sequence"] = "sequence";
    PositionProps["PositionTypeName"] = "position_type_name";
    PositionProps["TermMemberName"] = "term_member_name";
})(PositionProps || (PositionProps = {}));

var TermStatus;
(function (TermStatus) {
    TermStatus["Past"] = "Past";
    TermStatus["Current"] = "Current";
    TermStatus["Overdue"] = "Overdue";
    TermStatus["Pending"] = "Pending";
    TermStatus["FutureNoNominations"] = "Future: No Nominations";
    TermStatus["FutureNominationClosed"] = "Future : Nominations Closed";
    TermStatus["FutureNominationOpen"] = "Future : Nominations Open";
    TermStatus["FutureNominationPending"] = "Future : Nominations Pending";
})(TermStatus || (TermStatus = {}));

var PortalFormProps;
(function (PortalFormProps) {
    PortalFormProps["Title"] = "title";
    PortalFormProps["ActiveDate"] = "active_date";
    PortalFormProps["ExpireDate"] = "expire_date";
    PortalFormProps["Status"] = "status";
})(PortalFormProps || (PortalFormProps = {}));

var PortalTileProps;
(function (PortalTileProps) {
    PortalTileProps["Title"] = "title";
    PortalTileProps["Position"] = "position";
    PortalTileProps["ActiveDate"] = "active_date";
    PortalTileProps["ExpireDate"] = "expire_date";
    PortalTileProps["Status"] = "status";
    PortalTileProps["Sequence"] = "sequence";
})(PortalTileProps || (PortalTileProps = {}));
var PortalTilePositions;
(function (PortalTilePositions) {
    PortalTilePositions["Primary"] = "primary";
    PortalTilePositions["Secondary"] = "secondary";
})(PortalTilePositions || (PortalTilePositions = {}));

var CommitteesTabs;
(function (CommitteesTabs) {
    CommitteesTabs["Committees"] = "Committees";
    CommitteesTabs["UpcomingMeetings"] = "Upcoming Meetings";
    CommitteesTabs["PastMeetings"] = "Past Meetings";
})(CommitteesTabs || (CommitteesTabs = {}));

var CompletedCourseColumns;
(function (CompletedCourseColumns) {
    CompletedCourseColumns["CompletedDate"] = "completed_date";
    CompletedCourseColumns["Title"] = "title";
    CompletedCourseColumns["CeCredits"] = "ce_credits";
})(CompletedCourseColumns || (CompletedCourseColumns = {}));

var CourseOnDemandStatusEnum;
(function (CourseOnDemandStatusEnum) {
    CourseOnDemandStatusEnum["Draft"] = "draft";
    CourseOnDemandStatusEnum["Active"] = "active";
    CourseOnDemandStatusEnum["Cancelled"] = "cancelled";
})(CourseOnDemandStatusEnum || (CourseOnDemandStatusEnum = {}));

var CoursesTabs;
(function (CoursesTabs) {
    CoursesTabs["Calendar"] = "Calendar";
    CoursesTabs["OnDemand"] = "OnDemand";
    CoursesTabs["Bundles"] = "Bundles";
    CoursesTabs["Bookings"] = "Bookings";
    CoursesTabs["Courses"] = "Courses";
})(CoursesTabs || (CoursesTabs = {}));

var OfficeProps;
(function (OfficeProps) {
    OfficeProps["BusinessName"] = "business_name";
    OfficeProps["OfficeNrdsId"] = "office_nrds_id";
    OfficeProps["OfficeMlsId"] = "office_mls_id";
    OfficeProps["OfficePhone"] = "office_phone";
    OfficeProps["DesignatedRealtor"] = "designated_realtor";
    OfficeProps["Type"] = "type";
    OfficeProps["ResoOfficeType"] = "reso_office_type";
    OfficeProps["AreaPhone"] = "area_phone";
    OfficeProps["Status"] = "status";
    OfficeProps["PrimaryAssociation"] = "primary_association";
})(OfficeProps || (OfficeProps = {}));
var OfficeRosterColumns;
(function (OfficeRosterColumns) {
    OfficeRosterColumns["FirstName"] = "first_name";
    OfficeRosterColumns["LastName"] = "last_name";
    OfficeRosterColumns["Role"] = "role_description";
    OfficeRosterColumns["Mobile"] = "mobile";
    OfficeRosterColumns["LicenseNumber"] = "license_number";
    OfficeRosterColumns["Expiry"] = "license_expiry";
})(OfficeRosterColumns || (OfficeRosterColumns = {}));

var RpacYearProps;
(function (RpacYearProps) {
    RpacYearProps["LocalTrigger"] = "local_trigger";
    RpacYearProps["StateQuotaMet"] = "state_quota_met";
    RpacYearProps["Local"] = "local";
    RpacYearProps["State"] = "state";
    RpacYearProps["Fed"] = "fed";
})(RpacYearProps || (RpacYearProps = {}));

var RpacTrusteeProps;
(function (RpacTrusteeProps) {
    RpacTrusteeProps["FirstName"] = "member_first_name";
    RpacTrusteeProps["LastName"] = "member_last_name";
    RpacTrusteeProps["Email"] = "member_email";
    RpacTrusteeProps["Phone"] = "member_phone";
})(RpacTrusteeProps || (RpacTrusteeProps = {}));

var RpacYearAssociationProps;
(function (RpacYearAssociationProps) {
    RpacYearAssociationProps["AssociationNrdsId"] = "association_nrds_id";
    RpacYearAssociationProps["AssociationName"] = "association_name";
    RpacYearAssociationProps["MemberCount"] = "member_count";
    RpacYearAssociationProps["Quota"] = "quota";
    RpacYearAssociationProps["Goal"] = "goal";
})(RpacYearAssociationProps || (RpacYearAssociationProps = {}));

var M1CertificationProps;
(function (M1CertificationProps) {
    M1CertificationProps["AssociationName"] = "association_show_name";
    M1CertificationProps["CertificationCode"] = "certification_code";
    M1CertificationProps["CourseNumber"] = "course_number";
    M1CertificationProps["CourseCompleteDate"] = "course_complete_date";
})(M1CertificationProps || (M1CertificationProps = {}));

var M1CoeProps;
(function (M1CoeProps) {
    M1CoeProps["AssociationNrdsId"] = "association_nrds_id";
    M1CoeProps["AssociationName"] = "association_show_name";
    M1CoeProps["CourseCode"] = "course_code";
    M1CoeProps["YearTaken"] = "year_taken";
    M1CoeProps["CycleNumber"] = "cycle_number";
    M1CoeProps["CourseCompletionDate"] = "course_completion_date";
})(M1CoeProps || (M1CoeProps = {}));

var M1DemographicProps;
(function (M1DemographicProps) {
    M1DemographicProps["AssociationName"] = "association_show_name";
    M1DemographicProps["Category"] = "category";
    M1DemographicProps["GroupCode"] = "group_code";
})(M1DemographicProps || (M1DemographicProps = {}));

var M1DuesPaymentsProps;
(function (M1DuesPaymentsProps) {
    M1DuesPaymentsProps["AssociationName"] = "association_show_name";
    M1DuesPaymentsProps["AssociationNrdsId"] = "association_nrds_id";
    M1DuesPaymentsProps["BillingYear"] = "billing_year";
    M1DuesPaymentsProps["PaymentType"] = "payment_type";
    M1DuesPaymentsProps["DuesPaidDate"] = "dues_paid_date";
    M1DuesPaymentsProps["PaymentAmount"] = "payment_amount";
    M1DuesPaymentsProps["EcControlNumber"] = "ec_control_number";
})(M1DuesPaymentsProps || (M1DuesPaymentsProps = {}));

var M1EducationProps;
(function (M1EducationProps) {
    M1EducationProps["AssociationNrdsId"] = "association_nrds_id";
    M1EducationProps["AssociationName"] = "association_show_name";
    M1EducationProps["GroupCode"] = "group_code";
    M1EducationProps["CourseCode"] = "course_code";
    M1EducationProps["CourseNumber"] = "course_number";
    M1EducationProps["CourseEndDate"] = "course_end_date";
})(M1EducationProps || (M1EducationProps = {}));

var M1EducationLevelProps;
(function (M1EducationLevelProps) {
    M1EducationLevelProps["AssociationNrdsId"] = "association_nrds_id";
    M1EducationLevelProps["AssociationName"] = "association_show_name";
    M1EducationLevelProps["EducationLevelCode"] = "show_education_level";
})(M1EducationLevelProps || (M1EducationLevelProps = {}));

var M1LanguageProps;
(function (M1LanguageProps) {
    M1LanguageProps["AssociationName"] = "association_show_name";
    M1LanguageProps["LanguageName"] = "language_name";
    M1LanguageProps["LanguageCode"] = "language_code";
    M1LanguageProps["TimestampSeq"] = "timestamp_seq";
})(M1LanguageProps || (M1LanguageProps = {}));

var M1MemberSecondaryProps;
(function (M1MemberSecondaryProps) {
    M1MemberSecondaryProps["AssociationName"] = "association_show_name";
    M1MemberSecondaryProps["AssociationNrdsId"] = "association_nrds_id";
    M1MemberSecondaryProps["MemberType"] = "show_member_type";
    M1MemberSecondaryProps["BusinessName"] = "business_name";
    M1MemberSecondaryProps["OfficeNrdsId"] = "office_nrds_id";
    M1MemberSecondaryProps["Status"] = "show_status";
    M1MemberSecondaryProps["StatusDate"] = "status_date";
    M1MemberSecondaryProps["SubClass"] = "sub_class";
})(M1MemberSecondaryProps || (M1MemberSecondaryProps = {}));

var M1MilitaryProps;
(function (M1MilitaryProps) {
    M1MilitaryProps["MemberNrdsId"] = "member_nrds_id";
    M1MilitaryProps["AssociationName"] = "association_show_name";
    M1MilitaryProps["AssociationNrdsId"] = "association_nrds_id";
    M1MilitaryProps["MilitaryServiceCode"] = "military_service_code";
    M1MilitaryProps["MilitaryServiceDescription"] = "military_service_description";
    M1MilitaryProps["TimestampSeq"] = "timestamp_seq";
})(M1MilitaryProps || (M1MilitaryProps = {}));

var FindOfficesProps;
(function (FindOfficesProps) {
    FindOfficesProps["OfficeNrdsId"] = "office_nrds_id";
    FindOfficesProps["BusinessName"] = "business_name";
    FindOfficesProps["DrFullName"] = "dr_full_name";
    FindOfficesProps["DrLicenseNumber"] = "dr_license_number";
    FindOfficesProps["OfficePrimaryBoardName"] = "office_primary_board_name";
    FindOfficesProps["OfficeAddress"] = "office_address";
    FindOfficesProps["DrMlsStatus"] = "dr_mls_status";
})(FindOfficesProps || (FindOfficesProps = {}));

var ContributionColumns;
(function (ContributionColumns) {
    ContributionColumns["RpacYearLabel"] = "rpac_year_label";
    ContributionColumns["ContributionDate"] = "contribution_date";
    ContributionColumns["ActivityType"] = "activity_type";
    ContributionColumns["AssociationName"] = "association_name";
    ContributionColumns["ContributionType"] = "contribution_type";
    ContributionColumns["TotalAmount"] = "total_amount";
    ContributionColumns["PaymentRef"] = "payment_ref";
})(ContributionColumns || (ContributionColumns = {}));

var RpacTabs;
(function (RpacTabs) {
    RpacTabs["Overview"] = "Overview";
    RpacTabs["RecentActivity"] = "Recent Activity";
    RpacTabs["History"] = "History";
})(RpacTabs || (RpacTabs = {}));
var RpacStateTabs;
(function (RpacStateTabs) {
    RpacStateTabs["Dashboard"] = "Dashboard";
    RpacStateTabs["History"] = "History";
    RpacStateTabs["MajorInvestors"] = "Major Investors";
    RpacStateTabs["Trustees"] = "Trustees";
})(RpacStateTabs || (RpacStateTabs = {}));
var RpacCorporateTabs;
(function (RpacCorporateTabs) {
    RpacCorporateTabs["RecentActivity"] = "Recent Activity";
    RpacCorporateTabs["History"] = "History";
})(RpacCorporateTabs || (RpacCorporateTabs = {}));

var ContributionSummaryColumns;
(function (ContributionSummaryColumns) {
    ContributionSummaryColumns["RpacYearLabel"] = "rpac_year_label";
    ContributionSummaryColumns["AwardLevelLabel"] = "award_level_label";
    ContributionSummaryColumns["PresidentCircle"] = "president_circle";
    ContributionSummaryColumns["TotalAmount"] = "total_amount";
})(ContributionSummaryColumns || (ContributionSummaryColumns = {}));

var UnreportedLicenseesColumns;
(function (UnreportedLicenseesColumns) {
    UnreportedLicenseesColumns["Number"] = "license_number";
    UnreportedLicenseesColumns["Name"] = "license_name";
    UnreportedLicenseesColumns["Expiry"] = "license_expiry";
    UnreportedLicenseesColumns["ResolveBy"] = "resolve_by_date";
    UnreportedLicenseesColumns["Sponsor"] = "sponsor_name";
})(UnreportedLicenseesColumns || (UnreportedLicenseesColumns = {}));

var UnreportedLicenseesActions;
(function (UnreportedLicenseesActions) {
    UnreportedLicenseesActions["MoveToLFRO"] = "Move to LFRO";
    UnreportedLicenseesActions["MoveToMLO"] = "Move to MLO";
    UnreportedLicenseesActions["PayULFee"] = "Pay UL Fee";
})(UnreportedLicenseesActions || (UnreportedLicenseesActions = {}));

var TGFormProps;
(function (TGFormProps) {
    TGFormProps["Name"] = "name";
    TGFormProps["Status"] = "status";
    TGFormProps["Category"] = "category";
    TGFormProps["Type"] = "form_type_name";
    TGFormProps["NumberOfResponses"] = "response_count";
    TGFormProps["NumberOfIntegrations"] = "integration_count";
    TGFormProps["RequiresNrdsId"] = "requires_nrds_id";
})(TGFormProps || (TGFormProps = {}));

var TGFormResponseProps;
(function (TGFormResponseProps) {
    TGFormResponseProps["Submitted"] = "submitted";
    TGFormResponseProps["MemberNrdsId"] = "member_nrds_id";
    TGFormResponseProps["PersonId"] = "person_id";
    TGFormResponseProps["DateCreated"] = "created_at";
    TGFormResponseProps["DateCompleted"] = "completed_at";
})(TGFormResponseProps || (TGFormResponseProps = {}));

var TGFormResponseBodyTypes;
(function (TGFormResponseBodyTypes) {
    TGFormResponseBodyTypes["Text"] = "text";
    TGFormResponseBodyTypes["Number"] = "number";
    TGFormResponseBodyTypes["Date"] = "date";
})(TGFormResponseBodyTypes || (TGFormResponseBodyTypes = {}));

var TGFormStatus;
(function (TGFormStatus) {
    TGFormStatus["Editing"] = "editing";
    TGFormStatus["Testing"] = "testing";
    TGFormStatus["Published"] = "published";
    TGFormStatus["Retired"] = "retired";
})(TGFormStatus || (TGFormStatus = {}));

var UserProps;
(function (UserProps) {
    UserProps["FirstName"] = "first_name";
    UserProps["LastName"] = "last_name";
    UserProps["Email"] = "email";
    UserProps["Status"] = "active";
})(UserProps || (UserProps = {}));

var AsyncReportProps;
(function (AsyncReportProps) {
    AsyncReportProps["CreatedAt"] = "created_at";
    AsyncReportProps["ExpireAt"] = "expire_at";
    AsyncReportProps["ReportName"] = "report_id";
    AsyncReportProps["Status"] = "status";
    AsyncReportProps["Label"] = "label";
    AsyncReportProps["Title"] = "title";
})(AsyncReportProps || (AsyncReportProps = {}));

var ReportCategoryProps;
(function (ReportCategoryProps) {
    ReportCategoryProps[ReportCategoryProps["cate"] = 0] = "cate";
})(ReportCategoryProps || (ReportCategoryProps = {}));

var SavedReportProps;
(function (SavedReportProps) {
    SavedReportProps["CreatedAt"] = "created_at";
    SavedReportProps["Visibility"] = "visibility";
    SavedReportProps["CreatedByName"] = "created_by_name";
    SavedReportProps["Favorite"] = "favorite";
    SavedReportProps["ReportName"] = "report_definition.title";
    SavedReportProps["ReportTitle"] = "report_title";
    SavedReportProps["Label"] = "label";
    SavedReportProps["SharedWith"] = "shared_with";
})(SavedReportProps || (SavedReportProps = {}));

var TGReportProps;
(function (TGReportProps) {
    TGReportProps["Name"] = "title";
    TGReportProps["Favorite"] = "favorite";
})(TGReportProps || (TGReportProps = {}));

var SegmentProps;
(function (SegmentProps) {
    SegmentProps["Name"] = "name";
    SegmentProps["Description"] = "description";
    SegmentProps["Area"] = "area";
    SegmentProps["Visibility"] = "visibility";
    SegmentProps["CreatedAt"] = "created_at";
    SegmentProps["Category"] = "category";
    SegmentProps["Status"] = "status";
    SegmentProps["StatusDate"] = "status_date";
    SegmentProps["CreatedByName"] = "created_by_name";
})(SegmentProps || (SegmentProps = {}));
var FilterTypes;
(function (FilterTypes) {
    FilterTypes["String"] = "string";
    FilterTypes["Integer"] = "integer";
    FilterTypes["Date"] = "date";
    FilterTypes["List"] = "list";
    FilterTypes["Multi"] = "multi";
})(FilterTypes || (FilterTypes = {}));
var Visibilities;
(function (Visibilities) {
    Visibilities["Global"] = "Global";
    Visibilities["JustMe"] = "Just Me";
})(Visibilities || (Visibilities = {}));
var Operators;
(function (Operators) {
    Operators["All"] = "All";
    Operators["Any"] = "Any";
    Operators["Combination"] = "Combination";
})(Operators || (Operators = {}));
var Monitors;
(function (Monitors) {
    Monitors["No"] = "No";
    Monitors["Daily"] = "Daily";
    Monitors["Weekly"] = "Weekly";
    Monitors["Monthly"] = "Monthly";
})(Monitors || (Monitors = {}));
var MonitorLevels;
(function (MonitorLevels) {
    MonitorLevels["Count"] = "Count";
    MonitorLevels["Detailed"] = "Detailed";
})(MonitorLevels || (MonitorLevels = {}));
const SEGMENT_ITEM_OPERATOR = [{
        label: 'And',
        value: 'and'
    }, {
        label: 'Or',
        value: 'or'
    }];
var SegmentFormPanelTabIds;
(function (SegmentFormPanelTabIds) {
    SegmentFormPanelTabIds["Detail"] = "detail";
    SegmentFormPanelTabIds["Filter"] = "filter";
})(SegmentFormPanelTabIds || (SegmentFormPanelTabIds = {}));
var SegmentStatusEnum;
(function (SegmentStatusEnum) {
    SegmentStatusEnum["Drafted"] = "drafted";
    SegmentStatusEnum["Published"] = "published";
    SegmentStatusEnum["Retired"] = "retired";
})(SegmentStatusEnum || (SegmentStatusEnum = {}));

var GenericParameterTypes;
(function (GenericParameterTypes) {
    GenericParameterTypes["String"] = "string";
    GenericParameterTypes["Integer"] = "integer";
    GenericParameterTypes["Date"] = "date";
    GenericParameterTypes["DateRange"] = "daterange";
    GenericParameterTypes["List"] = "list";
    GenericParameterTypes["MultiDropdown"] = "multi";
    GenericParameterTypes["SingleDropdown"] = "single";
    GenericParameterTypes["Dynamic"] = "dynamic";
    GenericParameterTypes["SelectMultipleOrdered"] = "multiordered";
    GenericParameterTypes["SelectMultipleUnordered"] = "multiunordered";
    GenericParameterTypes["SegmentSelector"] = "segment";
})(GenericParameterTypes || (GenericParameterTypes = {}));

var CoursePriceProps;
(function (CoursePriceProps) {
    CoursePriceProps["BillingYear"] = "billing_year";
    CoursePriceProps["EventBillingType"] = "event_billing_type_display_name";
    CoursePriceProps["Price"] = "price";
    CoursePriceProps["AssociationBillingType"] = "association_billing_type_display_name";
    CoursePriceProps["AssociationPrice"] = "association_price";
})(CoursePriceProps || (CoursePriceProps = {}));

var InstructorCourseProps;
(function (InstructorCourseProps) {
    InstructorCourseProps["CourseName"] = "course_name";
    InstructorCourseProps["InstructorFullName"] = "instructor_full_name";
    InstructorCourseProps["Status"] = "status";
})(InstructorCourseProps || (InstructorCourseProps = {}));

var InstructorLicenseFeeProps;
(function (InstructorLicenseFeeProps) {
    InstructorLicenseFeeProps["BillingYear"] = "billing_year";
    InstructorLicenseFeeProps["Price"] = "price";
    InstructorLicenseFeeProps["InstructorName"] = "instructor_full_name";
    InstructorLicenseFeeProps["Status"] = "paid_status";
})(InstructorLicenseFeeProps || (InstructorLicenseFeeProps = {}));

var PayScaleProps;
(function (PayScaleProps) {
    PayScaleProps["Name"] = "name";
    PayScaleProps["FlatRate"] = "flat_rate_amount";
    PayScaleProps["PerHour"] = "per_hour_amount";
    PayScaleProps["PerStudent"] = "per_student_amount";
    PayScaleProps["Status"] = "status";
})(PayScaleProps || (PayScaleProps = {}));

var PurchasedPackageProps;
(function (PurchasedPackageProps) {
    PurchasedPackageProps["BillingYear"] = "billing_year";
    PurchasedPackageProps["Name"] = "name";
    PurchasedPackageProps["CreatedDate"] = "created_at";
})(PurchasedPackageProps || (PurchasedPackageProps = {}));

var StateBroadcastClassProps;
(function (StateBroadcastClassProps) {
    StateBroadcastClassProps["ClassStartDate"] = "class_detail_start_date";
    StateBroadcastClassProps["ClassStartTime"] = "class_detail.start_time";
    StateBroadcastClassProps["ClassEndDate"] = "class_detail.end_date";
    StateBroadcastClassProps["ClassEndTime"] = "class_detail.end_time";
    StateBroadcastClassProps["ClassName"] = "class_detail_name";
    StateBroadcastClassProps["ClassDeliveryType"] = "class_detail.delivery_type";
    StateBroadcastClassProps["ClassShowDeliveryType"] = "class_detail.show_delivery_type";
    StateBroadcastClassProps["Status"] = "status";
    StateBroadcastClassProps["CountOfCourseClass"] = "course_classes";
    StateBroadcastClassProps["TimesCount"] = "class_detail.times_count";
    StateBroadcastClassProps["InstructorsCount"] = "class_detail.instructors_count";
})(StateBroadcastClassProps || (StateBroadcastClassProps = {}));

var StateCertificationProps;
(function (StateCertificationProps) {
    StateCertificationProps["Name"] = "name";
    StateCertificationProps["Type"] = "type";
    StateCertificationProps["ShowType"] = "show_type";
    StateCertificationProps["ElectiveHours"] = "elective_hours";
})(StateCertificationProps || (StateCertificationProps = {}));

var StateCertificationCourseProps;
(function (StateCertificationCourseProps) {
    StateCertificationCourseProps["CourseName"] = "course.name";
    StateCertificationCourseProps["CourseNumber"] = "course.course_number";
    StateCertificationCourseProps["Mandatory"] = "mandatory";
})(StateCertificationCourseProps || (StateCertificationCourseProps = {}));

var StateClassDetailProps;
(function (StateClassDetailProps) {
    StateClassDetailProps["ClassTime"] = "class_time";
    StateClassDetailProps["InstructorClass"] = "instructor_class";
    StateClassDetailProps["TimesCount"] = "times_count";
    StateClassDetailProps["InstructorsCount"] = "instructors_count";
})(StateClassDetailProps || (StateClassDetailProps = {}));

var StateClassTimeProps;
(function (StateClassTimeProps) {
    StateClassTimeProps["ClassDate"] = "class_date";
    StateClassTimeProps["StartTime"] = "start_time";
    StateClassTimeProps["EndTime"] = "end_time";
})(StateClassTimeProps || (StateClassTimeProps = {}));

var ContinuingEducationTypeProps;
(function (ContinuingEducationTypeProps) {
    ContinuingEducationTypeProps["Name"] = "name";
    ContinuingEducationTypeProps["Code"] = "code";
    ContinuingEducationTypeProps["Status"] = "status";
})(ContinuingEducationTypeProps || (ContinuingEducationTypeProps = {}));

var StateCourseProps;
(function (StateCourseProps) {
    StateCourseProps["Name"] = "name";
    StateCourseProps["CourseNumber"] = "course_number";
    StateCourseProps["Type"] = "type";
    StateCourseProps["Status"] = "status";
    StateCourseProps["Provider"] = "provider_name";
})(StateCourseProps || (StateCourseProps = {}));

var StateCourseClassProps;
(function (StateCourseClassProps) {
    StateCourseClassProps["BillingEntityName"] = "billing_entity_display_name";
    StateCourseClassProps["Status"] = "status";
    StateCourseClassProps["Syndicate"] = "syndicate";
    StateCourseClassProps["Price"] = "price";
    StateCourseClassProps["StartDate"] = "start_date";
    StateCourseClassProps["ClassTimesCount"] = "class_times_count";
    StateCourseClassProps["Name"] = "name";
    StateCourseClassProps["Type"] = "type";
    StateCourseClassProps["HostedBy"] = "hosted_by";
    StateCourseClassProps["CourseNumber"] = "course_number";
    StateCourseClassProps["AttendeesCount"] = "attendees_count";
})(StateCourseClassProps || (StateCourseClassProps = {}));

var StateExamClassmarkerTestProps;
(function (StateExamClassmarkerTestProps) {
    StateExamClassmarkerTestProps["TestName"] = "test_name";
    StateExamClassmarkerTestProps["TestId"] = "test_id";
})(StateExamClassmarkerTestProps || (StateExamClassmarkerTestProps = {}));

var StateInstructorProps;
(function (StateInstructorProps) {
    StateInstructorProps["FirstName"] = "first_name";
    StateInstructorProps["LastName"] = "last_name";
    StateInstructorProps["Phone"] = "mobile";
    StateInstructorProps["Status"] = "status";
    StateInstructorProps["BillingEntity"] = "billing_entity_id";
    StateInstructorProps["BillingEntityDisplayName"] = "billing_entity_display_name";
})(StateInstructorProps || (StateInstructorProps = {}));

var StateInstructorClassProps;
(function (StateInstructorClassProps) {
    StateInstructorClassProps["InstructorFirstName"] = "instructor.first_name";
    StateInstructorClassProps["InstructorLastName"] = "instructor.last_name";
    StateInstructorClassProps["PayScaleName"] = "pay_scale.name";
})(StateInstructorClassProps || (StateInstructorClassProps = {}));

var StatePrepaidBandProps;
(function (StatePrepaidBandProps) {
    StatePrepaidBandProps["Name"] = "name";
    StatePrepaidBandProps["Status"] = "status";
    StatePrepaidBandProps["Default"] = "default";
})(StatePrepaidBandProps || (StatePrepaidBandProps = {}));

var StatePrepaidPackageProps;
(function (StatePrepaidPackageProps) {
    StatePrepaidPackageProps["BillingYear"] = "billing_year";
    StatePrepaidPackageProps["Name"] = "name";
    StatePrepaidPackageProps["Status"] = "status";
    StatePrepaidPackageProps["CourseCount"] = "course_count";
    StatePrepaidPackageProps["Purchased"] = "purchased";
})(StatePrepaidPackageProps || (StatePrepaidPackageProps = {}));

var StatePrepaidPriceProps;
(function (StatePrepaidPriceProps) {
    StatePrepaidPriceProps["PrepaidBand"] = "prepaid_band_display_name";
    StatePrepaidPriceProps["PrepaidBandId"] = "prepaid_band_id";
    StatePrepaidPriceProps["EventBillingType"] = "event_billing_type_display_name";
    StatePrepaidPriceProps["Price"] = "price";
})(StatePrepaidPriceProps || (StatePrepaidPriceProps = {}));

var StateSubscriptionBandProps;
(function (StateSubscriptionBandProps) {
    StateSubscriptionBandProps["Name"] = "name";
    StateSubscriptionBandProps["Status"] = "status";
})(StateSubscriptionBandProps || (StateSubscriptionBandProps = {}));

var StateSubscriptionPackageProps;
(function (StateSubscriptionPackageProps) {
    StateSubscriptionPackageProps["BillingYear"] = "billing_year";
    StateSubscriptionPackageProps["Name"] = "name";
    StateSubscriptionPackageProps["Status"] = "status";
    StateSubscriptionPackageProps["Purchased"] = "purchased";
    StateSubscriptionPackageProps["ClassCount"] = "class_count";
})(StateSubscriptionPackageProps || (StateSubscriptionPackageProps = {}));

var StateSubscriptionPriceProps;
(function (StateSubscriptionPriceProps) {
    StateSubscriptionPriceProps["SubscriptionBand"] = "subscription_band_display_name";
    StateSubscriptionPriceProps["SubscriptionBandId"] = "subscription_band_id";
    StateSubscriptionPriceProps["EventBillingType"] = "event_billing_type_display_name";
    StateSubscriptionPriceProps["EventBillingTypeId"] = "event_billing_type_id";
    StateSubscriptionPriceProps["Price"] = "price";
})(StateSubscriptionPriceProps || (StateSubscriptionPriceProps = {}));

var StateSubscriptionClassProps;
(function (StateSubscriptionClassProps) {
    StateSubscriptionClassProps["Date"] = "class_detail_start_date";
    StateSubscriptionClassProps["Name"] = "class_detail_name";
    StateSubscriptionClassProps["CountOfCourseClass"] = "course_classes";
    StateSubscriptionClassProps["TimesCount"] = "class_detail.times_count";
    StateSubscriptionClassProps["InstructorsCount"] = "class_detail.instructors_count";
    StateSubscriptionClassProps["ClassDeliveryType"] = "class_detail.delivery_type";
    StateSubscriptionClassProps["ClassShowDeliveryType"] = "class_detail.show_delivery_type";
})(StateSubscriptionClassProps || (StateSubscriptionClassProps = {}));

var TGProviderProps;
(function (TGProviderProps) {
    TGProviderProps["Name"] = "name";
    TGProviderProps["ProviderNumber"] = "provider_number";
    TGProviderProps["RegistrationState"] = "registration_state";
    TGProviderProps["RegistrationExpiry"] = "registration_expiry";
    TGProviderProps["Status"] = "status";
})(TGProviderProps || (TGProviderProps = {}));

var StateCourseClassLoadsProps;
(function (StateCourseClassLoadsProps) {
    StateCourseClassLoadsProps["CreatedAt"] = "created_at";
    StateCourseClassLoadsProps["AttendeesCount"] = "attendees_count";
    StateCourseClassLoadsProps["LoadedByName"] = "loaded_by_name";
})(StateCourseClassLoadsProps || (StateCourseClassLoadsProps = {}));

var StateInstructorCourseProps;
(function (StateInstructorCourseProps) {
    StateInstructorCourseProps["Status"] = "status";
})(StateInstructorCourseProps || (StateInstructorCourseProps = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { AsyncReportProps, AttendanceType, BillingEntityProps, BillingEntityUserProps, CommitteeStaffProps, CommitteeTypeProps, CommitteesTabs, CompletedCourseColumns, ContinuingEducationTypeProps, ContributionColumns, ContributionSummaryColumns, CourseOnDemandStatusEnum, CoursePriceProps, CoursesTabs, CreditRequestProps, FilterTypes, FindOfficesProps, GenericParameterTypes, IncidentColumns, InstructorCourseProps, InstructorLicenseFeeProps, InvoiceActivityProps, InvoiceProps, InvoiceStatusEnum, M1CertificationProps, M1CoeProps, M1DemographicProps, M1DuesPaymentsProps, M1EducationLevelProps, M1EducationProps, M1LanguageProps, M1MemberSecondaryProps, M1MilitaryProps, MeetingColumns, MonitorLevels, Monitors, MyInvoicesColumns, MyPaymentsColumns, OfficeProps, OfficeRosterColumns, Operators, PayScaleProps, PaymentStatus, PaymentStepStatus, PersonProps, PersonSubscriptionProps, PortalFormProps, PortalTilePositions, PortalTileProps, PositionProps, PurchasedPackageProps, RSVP, RecnPaymentMethodType, ReportCategoryProps, RpacCorporateTabs, RpacStateTabs, RpacTabs, RpacTrusteeProps, RpacYearAssociationProps, RpacYearProps, SEGMENT_ITEM_OPERATOR, SavedReportProps, SegmentFormPanelTabIds, SegmentProps, SegmentStatusEnum, StateBroadcastClassProps, StateCertificationCourseProps, StateCertificationProps, StateClassDetailProps, StateClassTimeProps, StateCourseClassLoadsProps, StateCourseClassProps, StateCourseProps, StateExamClassmarkerTestProps, StateInstructorClassProps, StateInstructorCourseProps, StateInstructorProps, StatePrepaidBandProps, StatePrepaidPackageProps, StatePrepaidPriceProps, StateSubscriptionBandProps, StateSubscriptionClassProps, StateSubscriptionPackageProps, StateSubscriptionPriceProps, TGFormProps, TGFormResponseBodyTypes, TGFormResponseProps, TGFormStatus, TGProviderProps, TGReportProps, TermApplicationTypeEnum, TermMemberColumns, TermProps, TermStatus, TermStatusEnum, UnreportedLicenseesActions, UnreportedLicenseesColumns, UserProps, Visibilities };
